<section>
  <div class="wrapper container-fluid">
    <article class="mrt-75" style="overflow-y: auto !important;overflow-x: hidden !important; min-height: calc(100vh - 117px);">
      <div class="row">
        <div class="form-container">
          <div class="container">
            <div class="header-section">
    <button mat-icon-button (click)="goBack()" class="back-button">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="title-section">
      <h2 *ngIf="siteName" class="site-intro-text">
        Here are new updates on your site <span class="site-name-highlight">{{ siteName }}</span> for {{ getCurrentMonthYear() }}.
      </h2>
      <h2 *ngIf="!siteName">Summary Details</h2>
    </div>
    <div class="date-range-section um-toolbar form-inline">
      <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field time-range-select">
        <mat-label>Time Range</mat-label>
        <mat-select panelClass="um-select-panel" [(ngModel)]="timeRange" (selectionChange)="onTimeRangeChange()">
          <mat-option value="day">Day</mat-option>
          <mat-option value="week">Week</mat-option>
          <mat-option value="month">Month</mat-option>
          <mat-option value="custom">Custom</mat-option>
        </mat-select>
      </mat-form-field>
      
      <div *ngIf="timeRange === 'custom'" class="custom-date-picker">
        <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field custom-date-field">
          <input matInput [ngxMatDatetimePicker]="startPicker" placeholder="Start Date" [(ngModel)]="startDate" (dateChange)="onCustomDateChange()">
          <mat-datepicker-toggle matSuffix [for]="$any(startPicker)"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #startPicker [showSeconds]="false"></ngx-mat-datetime-picker>
        </mat-form-field>
        
        <mat-form-field appearance="fill" floatLabel="always" class="form-field filter-field custom-date-field">
          <input matInput [ngxMatDatetimePicker]="endPicker" placeholder="End Date" [(ngModel)]="endDate" (dateChange)="onCustomDateChange()">
          <mat-datepicker-toggle matSuffix [for]="$any(endPicker)"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #endPicker [showSeconds]="false"></ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="summary-content-section" *ngIf="summaryData">
    <div class="date-range-heading">
      <span class="date-range-text">{{ getDateRangeText() }} by the Numbers</span>
    </div>
    
    <div class="metrics-grid">
      <div class="metric-card">
        <div class="metric-value">{{ summaryData.humanReviewCount || 0 }}</div>
        <div class="metric-label">Agent Review</div>
      </div>
      
      <div class="metric-card">
        <div class="metric-value">{{ summaryData.activityCount || 0 }}</div>
        <div class="metric-label">Escalated Events</div>
      </div>
      
      <div class="metric-card">
        <div class="metric-value">{{ summaryData.threatCount || 0 }}</div>
        <div class="metric-label">Threat Events</div>
      </div>
      
      <div class="metric-card">
        <div class="metric-value">{{ summaryData.alarmCount || 0 }}</div>
        <div class="metric-label">Alarm Activations</div>
      </div>
      
      <div class="metric-card">
        <div class="metric-value">{{ summaryData.pcScCalled || 0 }}</div>
        <div class="metric-label">Call/Texts to You</div>
      </div>
      
      <div class="metric-card">
        <div class="metric-value">{{ summaryData.policeNotified || 0 }}</div>
        <div class="metric-label">Police Calls</div>
      </div>
      
      <div class="metric-card total-card">
        <div class="metric-value">{{ getTotalCount() }}</div>
        <div class="metric-label">Total Count</div>
      </div>
      
      <div class="metric-card">
        <div class="metric-value">{{ (summaryData.arrestIncidents || []).length }}</div>
        <div class="metric-label">Arrest Incidents</div>
      </div>
      
      <div class="metric-card">
        <div class="metric-value">{{ (summaryData.deterredIncidents || []).length }}</div>
        <div class="metric-label">Deterred Incidents</div>
      </div>
      
      <div class="metric-card">
        <div class="metric-value">{{ (summaryData.interventionIncidents || []).length }}</div>
        <div class="metric-label">Intervention Incidents</div>
      </div>
    </div>
  </div>
  
  <!-- Incidents Sections -->
  <div class="incidents-section" *ngIf="summaryData">
    <!-- Deterred Incidents -->
    <div class="incident-type-section" *ngIf="summaryData.deterredIncidents && summaryData.deterredIncidents.length > 0">
      <h3 class="incident-type-title">Deterred Incidents ({{ summaryData.deterredIncidents.length }})</h3>
      <div class="incidents-grid">
        <div class="incident-card" *ngFor="let incident of summaryData.deterredIncidents">
          <div class="incident-thumbnail" *ngIf="incident.thumbnail">
            <img [src]="incident.thumbnail" [alt]="incident.id" (error)="onImageError($event)">
          </div>
          <div class="incident-content">
            <div class="incident-date">{{ incident.dateTime }}</div>
            <div class="incident-description">{{ incident.description }}</div>
            <div class="incident-actions" *ngIf="incident.archiveURl">
              <a [href]="incident.archiveURl" target="_blank" class="view-video-link">View Video</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Arrest Incidents -->
    <div class="incident-type-section" *ngIf="summaryData.arrestIncidents && summaryData.arrestIncidents.length > 0">
      <h3 class="incident-type-title">Arrest Incidents ({{ summaryData.arrestIncidents.length }})</h3>
      <div class="incidents-grid">
        <div class="incident-card" *ngFor="let incident of summaryData.arrestIncidents">
          <div class="incident-thumbnail" *ngIf="incident.thumbnail">
            <img [src]="incident.thumbnail" [alt]="incident.id" (error)="onImageError($event)">
          </div>
          <div class="incident-content">
            <div class="incident-date">{{ incident.dateTime }}</div>
            <div class="incident-description">{{ incident.description }}</div>
            <div class="incident-actions" *ngIf="incident.archiveURl">
              <a [href]="incident.archiveURl" target="_blank" class="view-video-link">View Video</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Intervention Incidents -->
    <div class="incident-type-section" *ngIf="summaryData.interventionIncidents && summaryData.interventionIncidents.length > 0">
      <h3 class="incident-type-title">Intervention Incidents ({{ summaryData.interventionIncidents.length }})</h3>
      <div class="incidents-grid">
        <div class="incident-card" *ngFor="let incident of summaryData.interventionIncidents">
          <div class="incident-thumbnail" *ngIf="incident.thumbnail">
            <img [src]="incident.thumbnail" [alt]="incident.id" (error)="onImageError($event)">
          </div>
          <div class="incident-content">
            <div class="incident-date">{{ incident.dateTime }}</div>
            <div class="incident-description">{{ incident.description }}</div>
            <div class="incident-actions" *ngIf="incident.archiveURl">
              <a [href]="incident.archiveURl" target="_blank" class="view-video-link">View Video</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="no-data-section" *ngIf="!summaryData">
    <p>No data available for the selected date range.</p>
  </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</section>

